import { createApp } from "vue";
import { router } from "./router";
import { Toast } from "vant";
import VueDompurifyHtml from "vue-dompurify-html";
import App from "./App.vue";
import { startReportError } from "@/utils";
import { createPinia } from "pinia";
import persistedstate from "pinia-plugin-persistedstate";
import "vant/es/toast/style";
import "@/assets/fonts/index.css";
import "./style/index.css";
import LongPressDirective from "./utils/longpress";

const pinia = createPinia();
console.log(import.meta.env.MODE);
pinia.use(persistedstate);
const app = createApp(App);
app.use(Toast);
app.use(router);
app.use(pinia);
app.directive("longpress", LongPressDirective);

app.use(VueDompurifyHtml, {
	default: {
		ADD_ATTR: ["target"], // 显式允许 target 属性
		ALLOWED_TAGS: ["br", "a"],
		ALLOWED_ATTR: ["href", "target", "rel", "style", "class"],
		// ALLOWED_URI_REGEXP: allowedUriRegex,
	},
});

function handleUnhandledRejection(event: PromiseRejectionEvent) {
	console.error("Unhandled Promise Rejection:", event.reason);
	startReportError({
		code: -1004,
		payload: JSON.stringify({ error: event.reason, source: "QI_LIAO_H5" }),
	});
}
console.log("env", import.meta.env);

// 全局错误监听
function setupGlobalErrorHandlers() {
	// 捕获 Vue 应用中的错误
	app.config.errorHandler = (err, instance, info) => {
		console.error("Vue Error:", err);
		console.error("Component Instance:", instance);
		console.error("Error Info:", info);
		// 添加标记
		(err as any)._isVue = true;
		// 发送到日志服务
		startReportError({
			code: -1001,
			payload: JSON.stringify({ error: err, instance, info, source: "QI_LIAO_H5" }),
		});
	};

	// 捕获全局 JavaScript 错误
	window.onerror = (message, source, lineno, colno, error) => {
		console.error("Global Error:", { message, source, lineno, colno, error });
		// 如果 error 对象是 Vue 捕获的，可以跳过
		if (error && (error as any)._isVue) return;
		startReportError({
			code: -1002,
			payload: JSON.stringify({ source: "QI_LIAO_H5", error, message, errSource: source, lineno, colno }),
		});
	};

	// 捕获未处理的 Promise 错误
	window.addEventListener("unhandledrejection", handleUnhandledRejection);

	// 捕获资源加载错误
	window.addEventListener("error", handleResourceError, true);
}

// 资源加载错误处理
function handleResourceError(event: any) {
	if (event.target instanceof HTMLImageElement || event.target instanceof HTMLScriptElement) {
		console.error("Resource Load Error:", { src: event.target.src || event.target.href });
		startReportError({
			code: -1003,
			payload: JSON.stringify({ source: "QI_LIAO_H5", src: event.target.src || event.target.href }),
		});
	}
}

// function removeGlobalErrorHandlers() {
// 	app.config.errorHandler = undefined;
// 	window.onerror = null;
// 	window.removeEventListener("unhandledrejection", handleUnhandledRejection);
// 	window.removeEventListener("error", handleResourceError, true);
// }

// 初始化全局错误监听
setupGlobalErrorHandlers();

// app.onUnmount(() => {
// 	removeGlobalErrorHandlers();
// });

app.mount("#app");
